<template>
  <div id="app">
    <pace-component/>
    <router-view v-bind:key="$route.name" />
    <vue-snotify/>
    <svg-icons/>
  </div>
</template>

<script>
import SvgIcons from './components/SvgIcons';
import PaceComponent from './components/PaceComponent';

export default {
  name: 'app',
  components: {
    PaceComponent,
    SvgIcons,
  },
  data() {
    return {
      locales: [],
      authenticated: true,
      candidateAuth: true,
    };
  },

  created() {
    this.loadAxiosSettings();
    this.loadLocale();
    this.fetchLocales();
  },

  updated() {
    this.$nextTick(() => {
      if (this.authenticated === false) {
        this.removeUserInfo(false);
        this.$router.replace({name: 'admin.login'}).catch(() => {
          this.authenticated = true;
        }).finally(() => {
          this.authenticated = true;
        });
        this.authenticated = true;
      }

      if (this.candidateAuth === false) {
        this.removeCandidateInfo(false);
        this.$router.replace({name: 'candidate.login'}).catch(() => {
          this.candidateAuth = true;
        }).finally(() => {
          this.candidateAuth = true;
        });
        this.candidateAuth = true;
      }
    });
  },

  methods: {
    loadAxiosSettings() {

      this.axios.interceptors.request.use((config) => {

        this.$Pace.start();

        if (!navigator.onLine) {

          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: this.$lang.app.noInternetConnection
          });

          return;

        }

        if (config.headers.common['Authorization']) {

          if (this.$route.path.includes('admin') && !this.getUserToken(false))
            config.headers.common.Authorization = null;

        }

        return config;

      });

      this.axios.interceptors.response.use(response => {
        this.$Pace.finish();
        return response;
      }, error => {

        this.$Pace.fail();

        let errorObject = Object.assign({}, error);

        if (!errorObject) {
          this.errorAskAdmin();
          console.log('no error object')
          return Promise.reject(error);
        }

        let errorResponse = errorObject.response;

        if (!errorResponse) {
          this.errorAskAdmin();
          console.log('no error response')
          return Promise.reject(error);
        }

        let errorStatus = errorResponse.status;

        if (!errorResponse.hasOwnProperty('status')) {
          this.errorAskAdmin();
          console.log('no error status')
          return Promise.reject(error);
        }
        switch (errorStatus) {
          case 401:

            if (this.$route.path.includes('admin')) {
              this.authenticated = false;
              localStorage.removeItem('auth_token');
              this.$store.dispatch('user/resetUser');
              this.$router.replace({name: 'admin.login'}).catch(() => {
              });
            } else {
              this.candidateAuth = false;
              this.removeCandidateInfo(false).then(() => {
                this.$router.replace({name: 'candidate.login'}).catch(() => {
                });
              });
            }

            break;

          case 403:
            this.$router.replace({name: 'errors.403'}).catch(() => {
            });
            break;
          case 404:
            let res = Object.assign({}, error).response;
            let query = {};
            if (res && res.data.message) {
              query.text = res.data.message;
            }
            this.$router.replace({name: 'errors.404', query: query}).catch(() => {
            });
            break;
          case 422:
            this.page422Handler(error);
            break;
          case 451:
            this.page451Handler(error);
            break;
          case 500:
            this.$snotify.error(errorResponse.data.message);
            break;
          case 429:
            this.$snotify.error('too many requests');
            break;
          default:
            console.log('default error')
            this.errorAskAdmin();
            break;
        }
        return Promise.reject(error);
      });
    },
  },

};
</script>
<style type="css">
@import './assets/css/style.css';
@import './assets/css/custom.css';
</style>

